import { useCurrentUser } from './user';
import { canUser } from 'services/permissions-service';

export const useCanUser = (permissionType, customList) => {
    const currentUser = useCurrentUser();

    return canUser(permissionType, customList, currentUser);
};
